import {handleAction} from 'redux-actions'
import {setWidgetData} from './actions'

import log from 'uix/logging'

// reduce root.data section, you can also export "root", "meta", "config"
export const data = [
  handleAction(
    setWidgetData,
    ({widget, ...data}, {payload}) => {
      return {...data, widget: {...widget, bibData: {...widget.bibData, ...payload.otid2data}}}
    },
    {widget: {bibData: {}}}
  ),
]
